/* eslint-disable max-lines */

import Vue from 'vue';
import { apiPath, apiUrl } from '../constants';

export const Register = Vue.resource(
  `${apiPath}/account`,
  {},
  {
    signup: { method: 'POST', url: `${apiPath}/account/signup/` },
    signupAgent: { method: 'POST', url: `${apiPath}/account/signup-agent/` },
    checkAgentInvitation: {
      method: 'GET',
      url: `${apiPath}/account/check-agent{/token}`,
    },
    verifyEmail: {
      method: 'POST',
      url: `${apiPath}/account/signup/verify-email/`,
      /*
       * Vue auth validates token on every request/response
       * In order to prevent vue auth from checking token on response
       */
      ignoreVueAuth: true,
    },
    registerPublisher: {
      method: 'POST',
      url: `${apiPath}/account/signup/register-publisher/`,
    },
    registerDeveloper: {
      method: 'POST',
      url: `${apiPath}/account/signup/register-developer-title/`,
    },
    getContact: { method: 'GET', url: `${apiPath}/account/contact/` },
    smsSend: { method: 'POST', url: `${apiPath}/account/signup/sms/send/` },
    smsVerify: { method: 'POST', url: `${apiPath}/account/signup/sms/verify/` },
    verifyNationalCodeOrId: {
      method: 'GET',
      url: `${apiPath}/account/signup/verify-national-code-or-id/`,
    },
    verifyDeveloperTitle: {
      method: 'POST',
      url: `${apiPath}/account/developer-titles/verify/`,
    },
  },
);

export const ForgetPassword = Vue.resource(
  `${apiPath}/account/password/reset{/action}/`,
  {},
  {
    requestResetPassword: { method: 'POST' },
    resetPassword: { method: 'PUT', params: { action: 'commit' } },
    checkTokenInfo: { method: 'GET', params: { action: 'verify' } },
  },
);

export const Publishers = Vue.resource(
  `${apiPath}/account{/type}/`,
  {},
  {
    updateContact: { method: 'PATCH', url: `${apiPath}/account/contact/` },
    updateLegal: { method: 'PATCH' },
  },
);

Publishers.uploadPaths = {
  nationalCard: `/${apiPath}/account/upload/national-card/`,
  passport: `/${apiPath}/account/upload/passport/`,
  companyCertificate: `/${apiPath}/account/upload/company-certificate/`,
  vat: `/${apiPath}/account/upload/vat/`,
};

export const DeveloperTitles = Vue.resource(
  `${apiPath}/account/developer-titles{/id}{/type}/`,
  {},
  {
    list: { method: 'GET' },
    updateSlug: { method: 'PUT', params: { type: 'slug' } },
    updateDetail: { method: 'PUT' },
  },
  {
    transformToCamelCase: true,
  },
);

export const UploadAPK = `/${apiPath}/uploadapk/`;

export const PublishActions = Vue.resource(
  `${apiPath}/apps{/packageName}{/type}/`,
  {},
  {
    publish: { method: 'POST', params: { type: 'publish' } },
    unpublish: { method: 'POST', params: { type: 'unpublish' } },
    publishRequest: { method: 'POST', params: { type: 'review-request' } },
    updatePublishRequest: {
      method: 'PATCH',
      params: { type: 'review-request' },
    },
    cancelPublishRequest: {
      method: 'DELETE',
      params: { type: 'review-request' },
    },
    warningRemovalRequest: {
      method: 'POST',
      params: { type: 'warning-removal-request' },
    },
    cancelWarningRemovalRequest: {
      method: 'DELETE',
      params: { type: 'review-request' },
    },
    suspensionRemovalRequest: {
      method: 'POST',
      params: { type: 'review-request' },
    },
    hide: { method: 'POST', params: { type: 'hide' } },
    unhide: { method: 'POST', params: { type: 'unhide' } },
    cancelSuspensionRemovalRequest: {
      method: 'DELETE',
      params: { type: 'review-request' },
    },
  },
);

export const IWMF = Vue.resource(`${apiPath}/iwmf{/packageName}/signup/`);

export const Advertisement = Vue.resource(
  `${apiPath}/adbazaar{/type}{/itemId}{/action}/`,
  {},
  {
    getCampaigns: { method: 'GET', params: { type: 'campaigns' } },
    getCampaignInfo: { method: 'GET', params: { type: 'campaigns' } },
    addCampaign: { method: 'POST', params: { type: 'campaigns' } },
    editCampaign: { method: 'PATCH', params: { type: 'campaigns' } },
    getDeveloperCredit: {
      method: 'GET',
      params: { type: 'budget', itemId: 'credit' },
    },
    getTransactions: {
      method: 'GET',
      params: { type: 'budget', itemId: 'transactions' },
    },
    getPaymentURL: {
      method: 'GET',
      params: { type: 'budget', itemId: 'start-payment' },
    },
    getInvoiceRanges: {
      method: 'GET',
      params: { type: 'finance', action: 'invoice-ranges' },
    },
  },
);

export const AdCampaignFinance = Vue.resource(
  `${apiPath}/adbazaar/campaigns{/itemId}{/type}/`,
  {},
  {
    getCampaignBudget: { method: 'GET', params: { type: 'budget' } },
    addCreditToCampaign: { method: 'POST', params: { type: 'budget' } },
    getCampaignGifts: { method: 'GET', params: { type: 'gifts' } },
    addGiftToCampaign: { method: 'POST', params: { type: 'gifts' } },
    getCampaignDailyCap: { method: 'GET', params: { type: 'daily-cap' } },
    changeCampaignDailyCap: { method: 'POST', params: { type: 'daily-cap' } },
  },
);

export const NegativeKeywords = Vue.resource(
  `${apiPath}/adbazaar/negative-keywords{/itemId}/`,
  {},
  {
    deleteKeyword: { method: 'DELETE' },
  },
);

export const Products = Vue.resource(
  `${apiPath}/apps{/packageName}/products{/sku}/`,
);

export const TrialSubscription = Vue.resource(
  `${apiPath}/apps{/packageName}{/action}/`,
  {},
  {
    getPeriod: {
      method: 'GET',
      params: { action: 'trial-sub' },
    },
    changePeriod: {
      method: 'PUT',
      params: { action: 'trial-sub' },
    },
    deactivate: {
      method: 'DELETE',
      params: { action: 'delete-trial-sub' },
    },
  },
);

export const Settlement = Vue.resource(
  `${apiPath}/settlements{/type}/`,
  {},
  {
    getSettlementHistory: {
      method: 'GET',
      params: { type: 'payment-history' },
    },
    getSettleableAmount: {
      method: 'GET',
      params: { type: 'settleable-balance' },
    },
    getSettlementRequests: {
      method: 'GET',
      params: { type: 'settlement-requests' },
    },
    getMisc: {
      method: 'GET',
      params: { type: 'reconciliation-miscellaneous-transactions' },
    },
  },
);

export const TaxInvoices = Vue.resource(
  `${apiPath}/tax-invoices/`,
  {},
  {
    getTaxInvoicesHistory: { method: 'GET' },
  },
);

export const TaxRate = Vue.resource(`${apiPath}/tax-rate/`);
export const SettlementSettings = Vue.resource(
  `${apiPath}/settlement-settings/`,
);
export const Clients = Vue.resource(`${apiPath}/clients{/id}/`);
export const Chart = Vue.resource(`${apiPath}/finance/sales-chart/`);
export const AdvertisementInvoice = Vue.resource(
  `${apiPath}/adbazaar/finance/invoice/`,
  {},
  {},
  { responseType: 'blob' },
);

export const Upload = function upload(...args) {
  return Vue.http.post(...args);
};

export const Contract = Vue.resource(
  `${apiPath}/contracts{/id}/`,
  {},
  {
    accept: { method: 'POST', url: `${apiPath}/accept-contract/` },
    current: { method: 'GET', params: { id: 'current' } },
  },
);

export const Membership = Vue.resource(
  `${apiPath}/account/membership{/action}{/type_api_version}{/type}/`,
  {},
  {
    extend: {
      method: 'POST',
      params: { action: 'extend', type_api_version: 'v2', type: 'request' },
    },
    verify: {
      method: 'GET',
      params: { action: 'extend', type_api_version: 'v2', type: 'info' },
    },
    getReceipts: { method: 'GET', params: { action: 'receipts' } },
    getReceiptFile: {
      method: 'GET',
      params: { action: 'receipts' },
      responseType: 'blob',
    },
  },
);

export const Account = Vue.resource(
  `${apiPath}/account`,
  {},
  {
    changePassword: {
      method: 'POST',
      url: `${apiPath}/account/password/change/`,
    },
  },
);

export { default as PhoneNumber } from './phoneNumber';
